





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ManualFeesDialogForm from '@/components/Products/ProductFees/Manual/ManualFeesDialogForm.vue';
import CreateManualFeeRequest from '@/models/Products/ProductFees/CreateManualFeeRequest';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'ManualFeesCreateDialog', components: { ManualFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    manualFeeRequest: CreateManualFeeRequest = new CreateManualFeeRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.manualFeeRequest = new CreateManualFeeRequest();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.createManualFee(this.manualFeeRequest);
        }
    }

}
